import { Component } from '@angular/core';
import {
  IWidgetSettings,
  TextWidgetSettings,
} from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/widget-settings';
import { TextConfiguration } from '@common-modules/shared/core/text/text-configuration';
import { IntegrableFormParams } from '@common-modules/shared/forms/integrable-form';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { BaseDashboardSettingsComponent } from '../core/base-dashboard-settings.component';

class DashboardTextSettingsModel {
  textName: string;
  textContent: string;
}

const COMPONENT_SELECTOR = 'ct-dashboard-text-settings';

@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './dashboard-text-settings.component.html',
  styleUrl: './dashboard-text-settings.component.scss',
  standalone: false,
})
export class DashboardTextSettingsComponent extends BaseDashboardSettingsComponent {
  initialModel: DashboardTextSettingsModel;
  textConfiguration: TextConfiguration;
  formOptions: FormlyFormOptions = {};

  private _updatedSettings: TextConfiguration;
  private _widgetSettings: TextWidgetSettings;

  textContent: string = '';
  quillModules = {
    toolbar: [[{ size: [] }], ['bold']],
  };

  fieldConfig: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          key: 'textName',
          type: 'input',
          className: 'col-8',
          props: {
            label: 'Title',
            required: true,
          },
        },
        {
          key: 'textContent',
          type: 'text-editor',
          className: 'col-12',
          props: {
            quillModules: this.quillModules,
            height: '50vh',
            width: '100%',
          },
        },
      ],
    },
  ];

  onModelChange(model: DashboardTextSettingsModel): void {
    this.initialModel.textContent = model.textContent;
    this._updatedSettings = this.modelToSettings(this.initialModel);
    this._widgetSettings.textConfiguration = this._updatedSettings;
  }

  getWidgetSettings(): IWidgetSettings {
    return this._widgetSettings;
  }

  setParams(params: IntegrableFormParams): void {
    this.formOptions.formState.op = params.op;
    this.formOptions = globalUtilsHelper.clone(this.formOptions);
  }

  getModel(): any {
    return {
      textContent: this.textContent,
    };
  }

  setInitialModel(model: TextWidgetSettings): void {
    if (!model) {
      model = new TextWidgetSettings();
    }
    if (!model.textConfiguration) {
      model.textConfiguration = new TextConfiguration();
      model.textConfiguration.textContent = '';
      model.textConfiguration.textName = '';
    }
    this._widgetSettings = model;
    this.textConfiguration = model.textConfiguration;
    this.initialModel = this.settingsToModel(this.textConfiguration);
    if (!this._updatedSettings) {
      this.onModelChange(this.initialModel);
    }
  }

  settingsToModel(settings: TextConfiguration): DashboardTextSettingsModel {
    if (!settings) {
      return null;
    }

    const model = {
      textName: settings.textName || '',
      textContent: settings.textContent || '',
    };

    return model;
  }

  modelToSettings(model: DashboardTextSettingsModel): TextConfiguration {
    if (!model || !this.textConfiguration) {
      return null;
    }

    this.textConfiguration.textName = model.textName || '';
    this.textConfiguration.textContent = model.textContent || '';

    return this.textConfiguration;
  }

  onIsValid(isValid: boolean): void {
    this.setIsValid(isValid);
  }

  onHasChanges(hasChanges: boolean): void {
    this.setHasChanges(hasChanges);
  }
}
